export default {
      id: "visa-usage",
      viewBox: "0 -6 32 24",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#visa",
      toString: function () {
        return this.url;
      }
    }